export function VoiceIdIcon({
  className = "w-5 h-5",
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M2.5 8.33333L2.5 11.6667M6.25 5L6.25 15M10 2.5V17.5M13.75 5V15M17.5 8.33333V11.6667" stroke="#667085" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "VoiceIdIcon";
